import { EProjectSection, trackEventV2 } from '../trackEventV2';
import {
  ELyrvEventName,
  IEarningsEstimateCompleted,
  ILyrvEstimateCalculated,
  ILyrvEstimateCompleted,
  ILyrvEstimateStarted,
} from './types';

export const trackLyrvEstimateStarted = (event: ILyrvEstimateStarted) => {
  trackEventV2(ELyrvEventName.LYRV_FLOW_EARNINGS_ESTIMATE_STARTED, EProjectSection.OWNER, {
    ...event,
  });
};

export const trackLyrvEstimateCalculated = (event: ILyrvEstimateCalculated) => {
  trackEventV2(ELyrvEventName.LYRV_FLOW_EARNINGS_ESTIMATE_CALCULATED, EProjectSection.OWNER, {
    ...event,
  });
};

export const trackLyrvEstimateCompleted = (event: ILyrvEstimateCompleted) => {
  trackEventV2(ELyrvEventName.LYRV_FLOW_EARNINGS_ESTIMATE_COMPLETED, EProjectSection.OWNER, {
    ...event,
  });
};

export const trackEarningsEstimateCompleted = (event: IEarningsEstimateCompleted) => {
  trackEventV2(ELyrvEventName.EARNINGS_ESTIMATE_COMPLETED, EProjectSection.OWNER, {
    ...event,
  });
};
